<script setup lang="ts">import { ref as _ref } from 'vue';

import PlacesTrayItem from '@consumer/modules/customizer/steps/stepPlaces/PlacesTrayItem.vue'
import type GiftTemplate from '@consumer/types/GiftTemplate'
import type { PlaceDetail } from '@consumer/types/serializers'
import VueDraggable from 'vuedraggable'

import 'floating-vue/dist/style.css'

withDefaults(defineProps<{
  gift: GiftTemplate
  canReorder: boolean
}>(), {  })

const emit = defineEmits<{
  removePlace: [PlaceDetail]
  reorderPlaces: []
}>()

const dragging = _ref(false)
</script>

<template>
  <div v-if="gift.places && gift.places.length > 0" class="py-2 px-0 lg:px-4">
    <template v-if="canReorder">
      <VueDraggable
        :list="gift.places"
        group="places"
        direction="horizontal"
        class="flex flex-wrap items-stretch justify-center gap-x-2 gap-y-2"
        itemKey="id"
        @start="dragging = true"
        @end="dragging = false"
        @update="emit('reorderPlaces')"
      >
        <template #item="{ element, index }">
          <PlacesTrayItem
            :place="element"
            :index="index"
            @removePlace="emit('removePlace', element)"
          />
        </template>
      </VueDraggable>
      <div
        class="text-center pt-4 text-grey-800"
        :class="gift.places.length >= 10 && 'hidden lg:block'"
      >
        Drag tags around to rearrange places.
      </div>
    </template>
    <div v-else class="px-4 lg:pt-8 text-grey-800 text-base">
      <div class="flex flex-wrap justify-center gap-x-2 gap-y-1">
        <div v-for="place, i in gift.places" :key="place.id" class="flex gap-2">
          <div class="no-underline" data-testid="static-place">
            {{ place.name }}
          </div>
          <span v-if="i < gift.places.length - 1" class="bullet">&bullet;</span>
        </div>
      </div>
    </div>
  </div>
</template>
